import { v1SitesList, v2SitesDetailsDetail } from '@on3/api';
import type { JoinPageProps } from '@on3/ui-lib/api/schema/custom-contracts';
import { withAuthentication } from '@on3/ui-lib/hocs/withAuthentication';
import { withValidUrl } from '@on3/ui-lib/hocs/withValidUrl';
import { proxyApi } from '@on3/ui-lib/index';
import { getFulfilledValue } from '@on3/ui-lib/utils/api';
import { JoinPage as Join } from '@public/components/Join/Page';
import { SubscribeLayout } from '@public/components/Layouts/SubscribeLayout';
import { createCanonicalUrl } from '@public/utils/meta';
import type { GetServerSideProps } from 'next';

const JoinPage = (props: JoinPageProps) => {
  const { siteDetails, sites, ...rest } = props;

  const canonical = createCanonicalUrl('/join/');
  const title = 'Select a team to subscribe to | On3';

  return (
    <SubscribeLayout {...rest} canonical={canonical} title={title}>
      <Join siteDetails={siteDetails} sites={sites} />
    </SubscribeLayout>
  );
};

export const getServerSideProps: GetServerSideProps<JoinPageProps> = async (
  ctx,
) => {
  const siteData = await withValidUrl.isValid(ctx);
  const userData = await withAuthentication.isAuth(ctx);

  if (!siteData?.currentSite?.key) {
    return {
      notFound: true,
    };
  }

  const siteKey = siteData.currentSite.key;

  try {
    const [_siteDetails, _sites] = await Promise.allSettled([
      v2SitesDetailsDetail(proxyApi, siteKey),
      v1SitesList(proxyApi, {}).then((res) => res.filter((s) => !!s.allowSubs)),
    ]);

    return {
      props: {
        pageType: 'user',
        siteData,
        userData,
        siteDetails: getFulfilledValue(_siteDetails),
        sites: getFulfilledValue(_sites) || [],
      },
    };
  } catch (error: any) {
    console.log({ error });

    return {
      props: {
        pageType: 'user',
        siteData,
        userData,
        siteDetails: null,
        sites: [],
      },
    };
  }
};

export default withValidUrl(JoinPage);
